import script from "./MobileIncludingMajors.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileIncludingMajors.vue?vue&type=script&lang=ts&setup=true"

import "./MobileIncludingMajors.vue?vue&type=style&index=0&id=f28224b6&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f28224b6"]])

export default __exports__